import {
  GET_PROFILES,
  SET_PROFILES,
  API_ERROR,
  CREATE_PROFILES,
  CREATED_PROFILES,
  RESET_PROFILES,
  GET_PROFILE,
  SET_PROFILE,
  EDIT_PROFILE,
  EDIT_PROFILE_SUCCESS,
  DELETE_PROFILE,
  DELETE_PROFILE_SUCCESS,
} from "./actionTypes";

export const resetProfiles = () => {
  return {
    type: RESET_PROFILES,
    payload: {},
  };
};

export const getProfiles = (page, qnt, name, description) => {
  return {
    type: GET_PROFILES,
    payload: { page, qnt, name, description },
  };
};

export const loadProfiles = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_PROFILES,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createProfile = (newProfileValues) => {
  return {
    type: CREATE_PROFILES,
    payload: { newProfileValues },
  };
};

export const createdProfile = (newProfileValues, message) => {
  return {
    type: CREATED_PROFILES,
    payload: { newProfileValues, message },
  };
};

export const getProfile = (idProfile, isForm) => {
  return {
    type: GET_PROFILE,
    payload: { idProfile, isForm },
  };
};

export const setProfile = (data) => {
  return {
    type: SET_PROFILE,
    payload: { data },
  };
};

export const editProfile = (newProfileValues, idProfile) => {
  return {
    type: EDIT_PROFILE,
    payload: { newProfileValues, idProfile },
  };
};

export const editProfileSuccess = (newProfileValues, message) => {
  return {
    type: EDIT_PROFILE_SUCCESS,
    payload: { newProfileValues, message },
  };
};

export const deleteProfile = (idProfile) => {
  return {
    type: DELETE_PROFILE,
    payload: { idProfile },
  };
};

export const deleteProfileSuccess = (idProfile, message) => {
  return {
    type: DELETE_PROFILE_SUCCESS,
    payload: { idProfile, message },
  };
};
